import styled from "styled-components";

export const NoData = styled.h2`
	position: absolute;
	left: 50%;
	top: 50%;
`;
